import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatSkeleton } from '@blocks-react/components/Skeleton';
import { useBreakpoint } from '../../../hooks';
import { PAGE_BREAKPOINTS } from '../../../constants/commonConstants';
import { v4 as uuid } from 'uuid';
export const DealerLocatorTermsLoader = () => {
    const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
    return (_jsxs("div", { className: "cat-u-margin-top-lg", children: [_jsx(CatSkeleton, { width: isMD ? '40%' : '80%', size: "sm", className: `cat-u-display-block cat-u-margin-bottom-${isMD ? 'xl' : 'md'}` }), _jsx("div", { className: `cat-u-padding-right-${isMD ? 'lg' : 'none'} cat-u-padding-left-${isMD ? 'lg' : 'none'}`, children: Array(isMD ? 16 : 21)
                    .fill(true)
                    .map((_skeletonCard) => {
                    return (_jsx(CatSkeleton, { className: "cat-u-display-block cat-u-margin-bottom-md", "data-testid": "skeleton-loader", size: "sm" }, `skeletonCard-${uuid()}`));
                }) })] }));
};
